module.exports = __webpack_public_path__ + "static/media/Q2 - Restaurants.1e7d6a54.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Survey/images/Q2 - Restaurants.png
// module id = 595
// module chunks = 0